export default __webpack_public_path__ + "static/media/mastercard.79b8498c.svg";